module.exports = __webpack_public_path__ + "img/login.ca1007ec.jpg";